import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FirmwareUpdateStore } from '@store';
import {
  BundleUpdateOtaType,
  OTAVersion,
  VersionListParams,
  Xota2OperationProcessItem,
  Xota2UpdateProgress,
  XotaBundleUpdateStep,
  XotaOperationStatus,
} from '@vi-iot/client/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BundleUpdateHelper } from 'src/app/@store/_common/bundle-update-helpers';

@Component({
  selector: 'app-firmware-update-version-list-updating',
  templateUrl: './firmware-update-version-list-updating.component.html',
  styleUrls: ['./firmware-update-version-list-updating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateVersionListUpdatingComponent implements OnInit {
  @Input() versionList: VersionListParams;
  @Input() xotaUpdateOperation: XotaOperationStatus;

  protected readonly BundleUpdateOtaType = BundleUpdateOtaType;
  protected readonly BundleUpdateStep = XotaBundleUpdateStep;
  protected readonly Xota2UpdateProgress = Xota2UpdateProgress;

  operationItems: Xota2OperationProcessItem[];

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}

  ngOnInit(): void {
    this.firmwareUpdateStore.xota2OperationProcess$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((operation: XotaOperationStatus) => {
        if (operation) {
          this.operationItems = BundleUpdateHelper.mappingOperationStatus(operation);
        }
      });
  }

  checkIfHaveVersion(otaVersions: OTAVersion[]): boolean {
    return BundleUpdateHelper.checkIfHaveVersion(otaVersions);
  }
}
